<div class="top-menu">
  <div class="menu-bar">

    <!-- ARCHIVO MENU -->
    <button mat-button [matMenuTriggerFor]="archivoMenu" class="menu-button">
      Archivo
    </button>
    <mat-menu #archivoMenu="matMenu" class="top-menu-dropdown">
      <button mat-menu-item (click)="onNewEscrito()">
        <mat-icon>edit_note</mat-icon>
        <span>Nuevo Escrito</span>
        <span class="shortcut">Ctrl+N</span>
      </button>
      <button mat-menu-item (click)="onNewPlantilla()">
        <mat-icon>description</mat-icon>
        <span>Nueva Plantilla</span>
        <span class="shortcut">Ctrl+Shift+N</span>
      </button>
      <mat-divider></mat-divider>
      <button mat-menu-item (click)="onSave()" [disabled]="!hasActiveTab()">
        <mat-icon>save</mat-icon>
        <span>Guardar</span>
        <span class="shortcut">Ctrl+S</span>
      </button>
      <button mat-menu-item (click)="onSaveAll()" [disabled]="!hasUnsavedChanges()">
        <mat-icon>save_alt</mat-icon>
        <span>Guardar Todo</span>
        <span class="shortcut">Ctrl+Shift+S</span>
      </button>
      <mat-divider></mat-divider>
      <button mat-menu-item (click)="onCloseTab()" [disabled]="!hasActiveTab()">
        <mat-icon>close</mat-icon>
        <span>Cerrar</span>
        <span class="shortcut">Ctrl+W</span>
      </button>
      <button mat-menu-item (click)="onCloseAll()" [disabled]="!hasActiveTab()">
        <mat-icon>close_fullscreen</mat-icon>
        <span>Cerrar Todo</span>
        <span class="shortcut">Ctrl+Shift+W</span>
      </button>
    </mat-menu>

    <!-- EDITAR MENU -->
    <button mat-button [matMenuTriggerFor]="editarMenu" class="menu-button">
      Editar
    </button>
    <mat-menu #editarMenu="matMenu" class="top-menu-dropdown">
      <button mat-menu-item (click)="onUndo()" [disabled]="!hasActiveTab()">
        <mat-icon>undo</mat-icon>
        <span>Deshacer</span>
        <span class="shortcut">Ctrl+Z</span>
      </button>
      <button mat-menu-item (click)="onRedo()" [disabled]="!hasActiveTab()">
        <mat-icon>redo</mat-icon>
        <span>Rehacer</span>
        <span class="shortcut">Ctrl+Y</span>
      </button>
      <mat-divider></mat-divider>
      <button mat-menu-item (click)="onFind()" [disabled]="!hasActiveTab()">
        <mat-icon>search</mat-icon>
        <span>Buscar</span>
        <span class="shortcut">Ctrl+F</span>
      </button>
      <button mat-menu-item (click)="onReplace()" [disabled]="!hasActiveTab()">
        <mat-icon>find_replace</mat-icon>
        <span>Reemplazar</span>
        <span class="shortcut">Ctrl+H</span>
      </button>
    </mat-menu>

    <!-- HERRAMIENTAS MENU -->
    <button mat-button [matMenuTriggerFor]="herramientasMenu" class="menu-button">
      Herramientas
    </button>
    <mat-menu #herramientasMenu="matMenu" class="top-menu-dropdown">
      <button mat-menu-item (click)="onProcessVariables()" [disabled]="!hasActiveTab()">
        <mat-icon>code</mat-icon>
        <span>Procesar Variables</span>
        <span class="shortcut">F5</span>
      </button>
      <mat-divider></mat-divider>
      <button mat-menu-item (click)="onExportPDF()" [disabled]="!hasActiveTab()">
        <mat-icon>picture_as_pdf</mat-icon>
        <span>Exportar a PDF</span>
        <span class="shortcut">Ctrl+E</span>
      </button>
    </mat-menu>

    <!-- VER MENU -->
    <button mat-button [matMenuTriggerFor]="verMenu" class="menu-button">
      Ver
    </button>
    <mat-menu #verMenu="matMenu" class="top-menu-dropdown">
      <button mat-menu-item (click)="onToggleSidebar()">
        <mat-icon>view_sidebar</mat-icon>
        <span>{{editorState?.sidebar?.isCollapsed ? 'Mostrar' : 'Ocultar'}} Panel Lateral</span>
        <span class="shortcut">Ctrl+B</span>
      </button>
      <mat-divider></mat-divider>
      <button mat-menu-item (click)="onShowExplorer()">
        <mat-icon>folder</mat-icon>
        <span>Explorador</span>
        <span class="shortcut">Ctrl+Shift+E</span>
      </button>
      <button mat-menu-item (click)="onShowVariables()">
        <mat-icon>code</mat-icon>
        <span>Variables</span>
        <span class="shortcut">Ctrl+Shift+V</span>
      </button>
      <button mat-menu-item (click)="onShowPlantillas()">
        <mat-icon>description</mat-icon>
        <span>Plantillas</span>
        <span class="shortcut">Ctrl+Shift+P</span>
      </button>
      <button mat-menu-item (click)="onShowVersions()">
        <mat-icon>history</mat-icon>
        <span>Versiones</span>
        <span class="shortcut">Ctrl+Shift+H</span>
      </button>
    </mat-menu>

    <!-- AYUDA MENU -->
    <button mat-button [matMenuTriggerFor]="ayudaMenu" class="menu-button">
      Ayuda
    </button>
    <mat-menu #ayudaMenu="matMenu" class="top-menu-dropdown">
      <button mat-menu-item (click)="onKeyboardShortcuts()">
        <mat-icon>keyboard</mat-icon>
        <span>Atajos de Teclado</span>
        <span class="shortcut">F1</span>
      </button>
      <mat-divider></mat-divider>
      <button mat-menu-item (click)="onAbout()">
        <mat-icon>info</mat-icon>
        <span>Acerca de</span>
      </button>
    </mat-menu>

    <!-- SPACER -->
    <div class="menu-spacer"></div>

    <!-- ACTIVE TAB INFO -->
    <div class="active-tab-info" *ngIf="hasActiveTab()">
      <span class="tab-title">{{ getActiveTabTitle() }}</span>
      <mat-icon class="unsaved-indicator" *ngIf="hasUnsavedChanges()">fiber_manual_record</mat-icon>
    </div>
  </div>
</div>
